import gear from "../../assets/gear.png";
import robot1 from "../../assets/robot1.png";
import señoraPeliroja from "../../assets/sueldoInteligente/señoraPeliroja.png";
import Button from "../Button";

function Caracteristicas() {
  return (
    <div className="relative overflow-hidden bg-[#e8f2f4] px-48">
      <div className="absolute inset-0 z-0" style={{ backgroundImage: `url(${robot1})`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain', backgroundPosition: 'left center', opacity: 0.3 }} />
      <div
        className="relative z-10 mx-auto flex flex-col md:flex-row gap-x-16 gap-y-10 items-center py-20 px-8 "
        style={{ backgroundColor: '#e8f2f4' }}
      >
        <div className="w-full md:w-1/2">
          <h2 className="text-3xl font-bold text-[#033d8e] mb-6">Características</h2>
          <ul className="space-y-4 text-[#034094] font-bold text-sm md:text-base">
            {[
              "Solo puedes inscribir una cuenta.",
              "Debes ser persona natural.",
              "Debes ser un cliente Bancolombia.",
              "El servicio quedará activo el día hábil posterior a la fecha de solicitud.",
              "Antes de solicitar el servicio debes tener claro el concepto cambiario, ósea el motivo por el cual recibes el dinero:"
            ].map((text, i) => (
              <li key={i} className="flex items-start gap-2">
                <img src={gear} alt="ícono" className="w-5 h-5 mt-1" />
                <span>{text}</span>
              </li>
            ))}
            <li className="pl-7 pt-2 text-sm md:text-base space-y-1">
              {[
                "1601 Otros conceptos.",
                "1695 Servicios culturales, artísticos y deportivos.",
                "1696 Pasajes.",
                "1703 Servicios de comunicaciones.",
                "1704 Comisiones no financieras.",
                "1706 Viajes de negocios, gastos educativos, pagos laborales a residentes, seguridad social.",
                "1707 Servicios diplomáticos, consulares y organismos internacionales.",
                "1809 Remesas de trabajadores.",
                "1810 Donaciones y transferencias que no generan contraprestación.",
                "1812 Remesas de trabajadores para la adquisición de vivienda.",
                "1815 Marcas, patentes, regalías y compensaciones.",
                "1840 Servicios empresariales, profesionales y técnicos.",
                "1711 Suscripciones, cuotas de afiliación y aportes periódicos.",
                "1713 Arrendamiento operativo.",
                "1714 Servicios de publicidad."
              ].map((item, j) => <div key={j}>{item}</div>)}
            </li>
          </ul>
        </div>
        <div className="w-full md:w-1/2 flex flex-col items-center px-10">
          <img src={señoraPeliroja} alt="Mujer feliz" className="rounded-2xl mb-6 w-full object-cover" />
          <Button text="Comienza" fullWidth={true} color="bg-[#36a31a]" textColor="text-white" rounded="rounded-full" />
        </div>
      </div>
    </div>
  );
}

export default Caracteristicas;
